import type { StoreActionApi } from '@atlassian/react-sweet-state';
import { getLinkedSpaces } from '../../../../services/index.tsx';
import type { State } from '../../types.tsx';

export const fetchLinkedSpaces =
	(projectKey: string) =>
	async ({ setState, getState }: StoreActionApi<State>) => {
		const initialState = { ...getState() };
		setState({
			...initialState,
			linkedSpaces: { ...initialState.linkedSpaces, isLoading: true },
		});
		try {
			const response = await getLinkedSpaces(projectKey);
			const linkedSpaces = response.map(({ spaceKey, spaceName }) => ({
				spaceKey,
				spaceName,
			}));
			setState({
				...initialState,
				linkedSpaces: {
					...initialState.linkedSpaces,
					isLoading: false,
					data: linkedSpaces,
					totalSize: linkedSpaces.length,
				},
			});
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			setState({
				...initialState,
				linkedSpaces: { ...initialState.linkedSpaces, isLoading: false, error },
			});
		}
	};
